import format from "date-fns/format";
import { ADD_TO_BASKET_URL } from "../../../../api/apiRoutes";
import { setBasketItemLimited } from "../../../../models/BasketItem";
import { BasketItem } from "../../../../models/BasketItem";
import useFacility from "../../../../../utils/hooks/useFacility";
import useApiRequest from "../../../../../utils/hooks/useApiRequest";

export default function useKortosfera() {
  const facilityIds = useFacility();
  const { post } = useApiRequest();
  const addGuideToBasket = async (ids: number, qnt: number) => {
    const formattedDate = format(new Date(), "yyyy-MM-dd");
    await post(ADD_TO_BASKET_URL, {
      ...setBasketItemLimited(facilityIds, `0,+${ids}`, formattedDate, qnt, []),
    });
  };

  const addKortosferaGuide = async (basketList: BasketItem[]) => {
    let biletyLab: number = 0;
    let opiekunLab: number = 0;

    let biletyWystawa: number = 0;
    let opiekunWystawa: number = 0;

    let biletyWydarzenieSpecjalne: number = 0;


    let biletyEdukator: number = 0;
    let opiekunEdukator: number = 0;

    let niepelnoLab: number = 0; // 0,126
    let asystentlab: number = 0; // 149

    let niepelnoWystawa: number = 0; // 125
    let asystentWystawa: number = 0; // 146

    let niepelnoEdukator: number = 0; // 132
    let asystentdukator: number = 0; // 150

    let biletyprzedszkole: number = 0;
    let opiekunprzedszkole: number = 0;



    // eslint-disable-next-line array-callback-return
    basketList.map((item: BasketItem) => {
      if (item.assortIds === "0,230") {
        biletyprzedszkole = biletyprzedszkole + item.qnt;
      }
      if (item.assortIds === "0,+231") {
        opiekunprzedszkole = opiekunprzedszkole + item.qnt;
      }

      if (item.assortIds === "0,273") {
        biletyLab = biletyLab + item.qnt;
      }
      if (item.assortIds === "0,+147") {
        opiekunLab = opiekunLab + item.qnt;
      }

      if (item.assortIds === "0,270") {
        biletyWystawa = biletyWystawa + item.qnt;
      }
      if (item.assortIds === "0,+148") {
        opiekunWystawa = opiekunWystawa + item.qnt;
      }
   
      if (item.assortIds === "0,+331") {
        biletyWydarzenieSpecjalne = biletyWydarzenieSpecjalne + item.qnt;
      } 

      if (item.assortIds === "0,130") {
        biletyEdukator = biletyEdukator + item.qnt;
      }

      //Noc bilogów
      if (item.assortIds === "0,236") {
        biletyEdukator = biletyEdukator + item.qnt;
      }
      if (item.assortIds === "0,239") {
        biletyEdukator = biletyEdukator + item.qnt;
      }
      ///
      if (item.assortIds === "0,+145") {
        opiekunEdukator = opiekunEdukator + item.qnt;
      }
      // os. z niepełnosprawnościami
      if (item.assortIds === "0,126") {
        niepelnoLab = niepelnoLab + item.qnt;
      }
      if (item.assortIds === "0,+149") {
        asystentlab = asystentlab + item.qnt;
      }
      if (item.assortIds === "0,125") {
        niepelnoWystawa = niepelnoWystawa + item.qnt;
      }
      if (item.assortIds === "0,+146") {
        asystentWystawa = asystentWystawa + item.qnt;
      }
      if (item.assortIds === "0,132") {
        niepelnoEdukator = niepelnoEdukator + item.qnt;
      }
      if (item.assortIds === "0,+150") {
        asystentdukator = asystentdukator + item.qnt;
      }
    });

    setTimeout(() => {
      if (biletyEdukator > 0 || opiekunEdukator > 0) {
        const guide = Math.ceil(biletyEdukator / 15);
        if (guide - opiekunEdukator !== 0) {
          addGuideToBasket(145, guide - opiekunEdukator);
        }
      }



   if (biletyWydarzenieSpecjalne > 0 || opiekunWystawa > 0) {
        const guide = Math.ceil(biletyWydarzenieSpecjalne / 15);
        if (guide - opiekunWystawa !== 0) {
          addGuideToBasket(148, guide - opiekunWystawa);
        }
      }


      

      if (biletyWystawa > 0 || opiekunWystawa > 0) {
        const guide = Math.ceil(biletyWystawa / 15);
        if (guide - opiekunWystawa !== 0) {
          addGuideToBasket(148, guide - opiekunWystawa);
        }
      }

      if (biletyprzedszkole > 0 || opiekunprzedszkole > 0) {
        const guide = Math.ceil(biletyprzedszkole / 15);
        if (guide - opiekunprzedszkole !== 0) {
          addGuideToBasket(231, guide - opiekunprzedszkole);
        }
      }

      if (biletyLab > 0 || opiekunLab > 0) {
        const guide = Math.ceil(biletyLab / 15);
        if (guide - opiekunLab !== 0) {
          addGuideToBasket(147, guide - opiekunLab);
        }
      }
      // Os. z niepełnosprawnością
      if (niepelnoLab > 0 || asystentlab > 0) {
        const guide = Math.ceil(niepelnoLab / 1);
        if (guide - asystentlab !== 0) {
          addGuideToBasket(149, guide - asystentlab);
        }
      }

      if (niepelnoWystawa > 0 || asystentWystawa > 0) {
        const guide = Math.ceil(niepelnoWystawa / 1);
        if (guide - asystentWystawa !== 0) {
          addGuideToBasket(146, guide - asystentWystawa);
        }
      }

      if (niepelnoEdukator > 0 || asystentdukator > 0) {
        const guide = Math.ceil(niepelnoEdukator / 1);
        if (guide - asystentdukator !== 0) {
          addGuideToBasket(150, guide - asystentdukator);
        }
      }
    }, 100);
  };

  return {
    addKortosferaGuide,
  };
}
